<template>
  <div v-if="info.title" class="contract-mobile-item">
    <div class="contract-sub-title">{{ info.title }}</div>
    <input
      v-if="!isStartGenerate"
      v-model="info.content"
      class="input mobile-input"
      type="text"
    />
    <div v-else class="input mobile-input">
      {{ info.content || "&nbsp;" }}
    </div>
  </div>
</template>

<script>
import { validatePhone, validateIdCard } from "@/utils/validate";
import { getTerminalInfo } from "@/utils/platformInfo";
import { Message } from "element-ui";
import { Toast } from "vant";
export default {
  name: "ContractMobile",

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSubmitData() {
      const { title, isRequire } = this.info;
      if (!isRequire) {
        if(this.info.content && !validatePhone(this.info.content)) {
          this.toast("请输入合法的手机号码");
          return false
        }
        return { partyBPhone: this.info.content };
      }
      if (!validatePhone(this.info.content)) {
        this.toast("请输入合法的手机号码");
        return false;
      }
      return {
        partyBPhone: this.info.content,
      };
    },
    toast(msg, type = "error") {
      const isMobile = getTerminalInfo() === "mobile";
      if (isMobile) {
        Toast({
          message: msg,
          position: "bottom",
        });
      } else {
        Message[type](msg);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.contract-mobile-item {
  margin-top: 30px;

  .mobile-input {
    margin-top: 10px;
    border-radius: 4px;
    width: 90%;
    font-size: 16px;
    padding: 4px 0;
    border: 1px solid #eee;
    padding-left: 10px;
  }
}

.contract-sub-title {
  font-size: 16px;
  font-weight: bold;
}</style>
